/**
 * FILE: apps/hub/src/components/LoadingSpinner.tsx
 * PURPOSE: Reusable UI component.
 * AGENT_CONTEXT: Shared component. Keep <200 lines. Extract sub-components if needed.
 * LAST_REVIEWED: 2026-05-07
 */

export function LoadingSpinner({ label = 'Loading...' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 text-sm text-muted-foreground">
      <div
        className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-primary border-r-fintree-emerald/70"
        aria-hidden
      />
      <span>{label}</span>
    </div>
  )
}
